---
meta:
  - title: Como crear un agente - IUSPRO Docs
  - description: Guía práctica para crear un agente útil, claro y fácil de reutilizar.
---

# Como crear un agente

Crear un agente consiste en dejar claro:

- qué información necesita recibir
- qué trabajo debe hacer primero
- qué trabajo debe hacer después
- qué resultado debería entregarle

## Paso 1: póngale un nombre claro

Use un nombre que le diga a cualquier persona qué resuelve ese agente.

Buenos ejemplos:

- “Diagnóstico de despido”
- “Respuesta a prevención registral”
- “Borrador de demanda de cobro”

## Paso 2: defina bien la información inicial

La primera parte del agente siempre es donde la persona aporta la información del asunto.

Piense en material de trabajo real, por ejemplo:

- hechos
- objetivo del cliente
- archivo de soporte
- puntos que se deben incluir

Evite pedir demasiadas cosas. Empiece por lo mínimo necesario.

## Paso 3: arme el trabajo en el orden natural

Una estructura muy común es:

1. recibir información del caso
2. hacer análisis jurídico
3. ordenar o transformar ese análisis
4. redactar
5. revisar

No todos los agentes necesitan todo eso.

## Paso 4: escriba instrucciones concretas

Cada parte funciona mejor cuando la instrucción es clara.

En vez de esto:

`Analiza`

mejor algo como:

`Analiza los hechos, identifica el marco jurídico aplicable en Costa Rica y señala los puntos fuertes y débiles del caso.`

Una buena regla es pensar:

> “¿Qué le pediría a un abogado junior si quiero que me deje adelantada esta parte?”

## Paso 5: use la herramienta correcta

- **Instrucción** para ordenar, resumir o transformar texto
- **Auri** para análisis jurídico
- **Búsqueda en la web** para buscar fuentes web con enlaces
- **Redactor** para crear un documento real
- **Revision** para revisar contra un manual
- **Traducción** para dejar una versión en otro idioma

## Crear desde una descripción

En la pantalla de crear agente también puede describir el trabajo en palabras normales y dejar que el sistema le
proponga una primera estructura.

Por ejemplo:

> “Quiero un agente que reciba hechos y documentos, haga un análisis laboral, convierta eso en argumentos y me deje un
> borrador de demanda.”

Eso sirve para arrancar más rápido.

Después conviene revisar y ajustar lo que el sistema le proponga.

## Etiquetas

Puede agregar etiquetas al agente para encontrarlo más fácil después.

Úselos para cosas simples como:

- laboral
- civil
- registral
- notarial
- cobro judicial

## Consejo práctico

Antes de guardar, hágase esta pregunta:

> “Si otra persona del despacho abre este agente mañana, ¿sabrá qué información poner y qué resultado esperar?”

Si la respuesta es sí, va bien.

## Siguiente lectura

- Entienda [cómo funciona cada parte del agente](/guias/agentes-como-funciona-cada-paso)
- Vea [buenas prácticas para diseñar agentes](/guias/agentes-buenas-practicas)
